import { apiRequest } from './client';
import { normalizePublicLocale } from '../utils/locale';

export function submitContactRequest(form, locale) {
  const publicLocale = normalizePublicLocale(locale);

  return apiRequest('/api/contact-requests', {
    method: 'POST',
    headers: {
      'Accept-Language': publicLocale,
    },
    body: JSON.stringify({
      name: form.name.trim(),
      phone: form.phone.trim(),
      email: form.email.trim(),
      message: form.message.trim(),
      website: form.website || '',
      locale: publicLocale,
    }),
  });
}
